export const CREATE_EDIT_SCHEME = 'create-edit-scheme';
export const UPDATE_SCHEME_STATUS = 'update-scheme-status';
